export const RadioChips = ({ legend, name, options, value, onChange, testId, className = "" }) => (
  <fieldset data-testid={testId} className={`m-0 min-w-0 border-0 p-0 ${className}`}>
    <legend className="p-0 text-sm font-medium leading-5 text-ax-text">{legend}</legend>
    <div
      className="mt-2 grid gap-2"
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
    >
      {options.map((o) => (
        <label key={o.value} className="relative block min-w-0">
          <input
            type="radio"
            name={name}
            value={o.value}
            checked={value === o.value}
            onChange={() => onChange(o.value)}
            data-testid={`${testId}-${o.value}`}
            className="peer sr-only"
          />
          <span
            className={`flex min-h-[48px] cursor-pointer items-center justify-center rounded-[8px] border px-2 py-2 text-center text-sm font-medium leading-5 transition-colors duration-150 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-ax-focus-ring ${
              value === o.value
                ? "tint-chip-active text-ax-link"
                : "border-ax-border bg-ax-surface text-ax-text hover:bg-ax-bg"
            } ${o.mono ? "font-mono text-[13px]" : ""}`}
          >
            {o.label}
          </span>
        </label>
      ))}
    </div>
  </fieldset>
);
